import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTargets.forEach(input => {
      input.addEventListener('input', this.removeHyphens.bind(this))
      input.addEventListener('keydown', this.preventHyphenInput.bind(this))
      input.addEventListener('paste', this.handlePaste.bind(this))
    })
  }

  removeHyphens(event) {
    const input = event.target
    const cursorPosition = input.selectionStart
    const originalValue = input.value
    const newValue = originalValue.replace(/-/g, '')

    if (originalValue !== newValue) {
      input.value = newValue
      const newCursorPosition = Math.max(0, cursorPosition - (originalValue.length - newValue.length))
      input.setSelectionRange(newCursorPosition, newCursorPosition)
    }
  }

  preventHyphenInput(event) {
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault()
    }
  }

  handlePaste(event) {
    event.preventDefault()
    const paste = (event.clipboardData || window.clipboardData).getData('text')
    const cleanedPaste = paste.replace(/-/g, '')

    const input = event.target
    const start = input.selectionStart
    const end = input.selectionEnd
    const currentValue = input.value

    input.value = currentValue.substring(0, start) + cleanedPaste + currentValue.substring(end)
    input.setSelectionRange(start + cleanedPaste.length, start + cleanedPaste.length)
  }
}
